module.exports = __webpack_public_path__ + "img/top-5-5.e754afe0.jpg";